import { render, staticRenderFns } from "./InstitutionApcTab.vue?vue&type=template&id=40b3b1c8"
import script from "./InstitutionApcTab.vue?vue&type=script&lang=js"
export * from "./InstitutionApcTab.vue?vue&type=script&lang=js"
import style0 from "./InstitutionApcTab.vue?vue&type=style&index=0&id=40b3b1c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports